import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Component } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { UncontrolledTooltip } from 'reactstrap';
export const CONVENTIONAL_COMMITS_ADD = 'add';
export const CONVENTIONAL_COMMITS_REMOVE = 'remove';
export const CONVENTIONAL_COMMITS_FIX = 'fix';
export const CONVENTIONAL_COMMITS_REFACTOR = 'refactor';
const CONVENTIONAL_COMMITS_RULES = {
    [CONVENTIONAL_COMMITS_ADD]: ['+', 'add:', 'feat:'],
    [CONVENTIONAL_COMMITS_REMOVE]: ['-', 'del:'],
    [CONVENTIONAL_COMMITS_FIX]: ['@', 'fix:'],
    [CONVENTIONAL_COMMITS_REFACTOR]: ['/', 'refactor:'],
};
export class ConventionalCommitMessage extends Component {
    render() {
        const { t, message, hash } = this.props;
        const transformedMessage = this.transformMessage(message);
        const tooltipTargetId = 'tooltip-' + hash.substring(0, 8);
        let conventionalCommit = '';
        if (transformedMessage.rule) {
            const conventionalMessage = t('conventionalCommit.' + transformedMessage.rule + 'Description');
            const className = 'conventional-commit conventional-commit--' + transformedMessage.rule;
            conventionalCommit = (_jsxs(_Fragment, { children: [_jsx("span", { className: className, id: tooltipTargetId, children: t('conventionalCommit.' + transformedMessage.rule) }), _jsx(UncontrolledTooltip, { target: tooltipTargetId, children: _jsx("small", { children: _jsxs(Trans, { i18nKey: "conventionalCommit.intro", values: { rule: conventionalMessage }, children: ["You use Conventional Commits, that is great! ", conventionalMessage, "."] }) }) })] }));
        }
        return (_jsxs(_Fragment, { children: [conventionalCommit, "\u00A0", transformedMessage.message] }));
    }
    //ToDo: Place transformMessage() outside the class
    transformMessage(message) {
        for (const rule of Object.keys(CONVENTIONAL_COMMITS_RULES)) {
            for (const keyword of CONVENTIONAL_COMMITS_RULES[rule]) {
                if (message.startsWith(keyword + ' ')) {
                    return {
                        message: message.substring(keyword.length + 1),
                        rule,
                    };
                }
            }
        }
        return {
            message,
        };
    }
}
export default withTranslation()(ConventionalCommitMessage);
